import type { PropsWithChildren } from "react";

import { graphql, useFragment } from "react-relay";

import { PageWithBreadCrumbs } from "app/components/layout/PageWithBreadCrumbs";
import { useSettingsBreadcrumbs } from "app/hooks/routing/useSettingsBreadcrumbs";

import type { Jun0SettingsPage_query$key } from "./__generated__/Jun0SettingsPage_query.graphql";

interface Props extends PropsWithChildren {
  queryRef: Jun0SettingsPage_query$key;
  /** Whether to wrap the page content in a card-like Paper */
  withPaper?: boolean;
}

export function Jun0SettingsPage({ queryRef, children, withPaper }: Props) {
  const data = useFragment(
    graphql`
      fragment Jun0SettingsPage_query on Query {
        ...PageWithBreadCrumbs_query
      }
    `,
    queryRef,
  );

  const breadcrumbs = useSettingsBreadcrumbs();

  return (
    <PageWithBreadCrumbs
      breadcrumbs={breadcrumbs}
      defaultTitle="Settings"
      queryRef={data}
      title="Jun0"
      withPaper={withPaper}
    >
      {children}
    </PageWithBreadCrumbs>
  );
}
